module.exports = __webpack_public_path__ + "media/images/no-image-229a685b3d390f4af8af5e14a555b8af.jpg";